window.br = window.br || {};
window.br.storeId = document.getElementById('storeId').value;

require("./product-gui");
require("./cart");
require("./checkout");